module.exports = __webpack_public_path__ + "media/Components/fonts/boldRaleway-6e5949c53c021f057c441b833430ec3d.ttf";